import { configAnalytics } from '@origin-digital/reporting-client';
import { configSumo, EnvironmentNames, LogLevel, alert } from '@origin-digital/reporting-client';
import * as ConfigService from './config/ConfigService';
import * as SumoLogger from 'sumo-logger';
import { injectGlobalStyles } from 'ts/global-styles';

const analyticsInitialise = () => {
  if (!ConfigService.getConfig()) {
    ConfigService.initialise();
  }
  configAnalytics({
    appName: ConfigService.getConfig() ? ConfigService.getAppName() : 'auth',
    debugToConsole: false,
  });
};
const loggingInitialise = () => {
  if (!ConfigService.getConfig()) {
    ConfigService.initialise();
  }

  configSumo({
    SumoLogger,
    sumoLogLevel: ConfigService.getSumoLogLevel() as LogLevel,
    consoleLogLevel: ConfigService.getSumoConsoleLogLevel() as LogLevel,
    sendOnErrors: ConfigService.getSendOnErrors(),
    appName: ConfigService.getAppName(),
    endpoint: ConfigService.getSumoEndpoint(),
    sourceEnv: ConfigService.getSumoSourceEnv() as EnvironmentNames,
    sourceCategory: ConfigService.getSumoCategory(),
  });
};

const initialiseApp = () => {
  injectGlobalStyles();
  loggingInitialise();
  analyticsInitialise();
  ConfigService.initialise();
};

export { initialiseApp };
